import { z } from "zod";
import { SitePackageIdSchema } from "./site-package.js";
export const RichnessScoreBandSchema = z.enum([
    "THIN",
    "MODERATE",
    "STRONG",
    "AUTHORITY_READY",
]);
export const RichnessSourceBreakdownV1Schema = z
    .object({
    confirmedActiveFields: z.number().int().min(0),
    agencyEnteredFields: z.number().int().min(0),
    intakeDerivedFields: z.number().int().min(0),
    unknownOrUnconfirmedFields: z.number().int().min(0),
})
    .strict();
export const RichnessDimensionFlagsV1Schema = z
    .object({
    hasContact: z.boolean(),
    hasServiceArea: z.boolean(),
    hasPrimaryService: z.boolean(),
    hasMultipleServices: z.boolean(),
    hasProofOrCredentials: z.boolean(),
    hasMedia: z.boolean(),
    hasSupportedClaims: z.boolean(),
    unconfirmedEvidenceUsed: z.boolean(),
})
    .strict();
export const BusinessGraphRichnessScoreV1Schema = z
    .object({
    schemaVersion: z.literal("business-graph-richness-score.v1.0"),
    score: z.number().int().min(0).max(100),
    band: RichnessScoreBandSchema,
    sourceBreakdown: RichnessSourceBreakdownV1Schema,
    dimensionFlags: RichnessDimensionFlagsV1Schema,
    policyVersion: z.string().min(1),
    evaluatedAt: z.string().datetime(),
    evaluatedFromBusinessGraphSnapshotHash: z.string(),
    confirmedFieldsOnly: z.literal(true),
})
    .strict();
export const RichnessGatePolicyV1Schema = z
    .object({
    schemaVersion: z.literal("richness-gate-policy.v1.0"),
    policyVersion: z.string().min(1),
    minimumScoreByPackage: z.record(SitePackageIdSchema, z.number().int().min(0).max(100)),
})
    .strict();
/** Product memory thresholds — verified in contract boundary tests (39/40, 59/60, 74/75). */
export const DEFAULT_RICHNESS_GATE_POLICY = RichnessGatePolicyV1Schema.parse({
    schemaVersion: "richness-gate-policy.v1.0",
    policyVersion: "RichnessGatePolicyV1",
    minimumScoreByPackage: {
        "package-one-page": 0,
        "package-basic-3": 0,
        "package-standard-5": 40,
        "package-growth-8": 60,
        "package-authority-10": 75,
        "package-authority-15": 75,
    },
});
export function getMinimumRichnessForPackage(sitePackageId, policy = DEFAULT_RICHNESS_GATE_POLICY) {
    return policy.minimumScoreByPackage[sitePackageId] ?? 100;
}
export function richnessScoreToBand(score) {
    if (score >= 75)
        return "AUTHORITY_READY";
    if (score >= 60)
        return "STRONG";
    if (score >= 40)
        return "MODERATE";
    return "THIN";
}
//# sourceMappingURL=business-graph-richness.js.map